<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: {
        prop_chartdata: Array,
        prop_labels: Array,
        prop_backgroundcolor: {
          type: Array,
          default: function () { return [
            "#005D80",
            "#FFCE54",
            "#FF4622",
            "#00B8D3",
            "#FF006D",
            "#8A0A76",
            "#0070B3",
            "#C5EBC8",
          ] }
        },
        prop_bordercolor: {
          type: Array,
          default: function () { return [] }
        },
    },
  data() {
    return {
      gradient: null,
      chartdata: {
        labels: this.prop_labels,
        datasets: [{
            label: 'none',
            data: this.prop_chartdata,
            backgroundColor: this.prop_backgroundcolor,
            borderColor: this.prop_bordercolor,
            borderWidth: this.prop_bordercolor ? 3 : 0,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
            display: false,
        },
        tooltips: {
            enabled: false,
        },
        legend: {
            display: false,
        },
        layout: {
            padding: {
                left: 10,
                right: 15,
                top: 15,
                bottom: 10
            }
        },
        scales : {
            xAxes : [{
                ticks : {
                    beginAtZero : true,
                    suggestedMin: 0,
                    suggestedMax: 100
                }   
            }]
        }
      }
    }
  },

  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
};
</script>
